import Cache from './Cache';

export default class Token extends Cache {
  constructor() {
    super('token');
  }
}
